import {readLocalStorageValue} from "@mantine/hooks";
import {bffApi} from "./bffApi";
import {LocalStorageKeys, UserRole} from "../../types";

/**
 * Returns whether experimental mode is active and whether the check is
 * still loading (waiting for user data from the API).
 *
 * Experimental mode requires both:
 * 1. The current user has rolleId === UserRole.Superbruker
 * 2. The experimentalMode localStorage flag is true
 */
export function useExperimentalMode(): {
    isExperimental: boolean;
    isLoading: boolean;
} {
    const {data: userData, isLoading} = bffApi.endpoints.getUser.useQuery();

    const experimentalMode = readLocalStorageValue({
        key: LocalStorageKeys.ExperimentalMode,
        defaultValue: false,
    });

    const isSuperbruker =
        userData !== undefined && userData.rolleId === UserRole.Superbruker;

    return {
        isExperimental: isSuperbruker && experimentalMode === true,
        isLoading,
    };
}
